import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { setLaunchParams } from '@slices/launchParamsSlice'
import { INTERNAL_CONSTANTS } from '@constants/internalConstants'
import { convertCase } from '@utils/miscUtils'

const REQUIRED_PARAMS = ['token', 'gameCode']

const { RESOLVING, INCOMPLETE, READY } = INTERNAL_CONSTANTS.LAUNCH_STATUS

export const useLaunchParams = () => {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const storedParams = useSelector((state) => state.launchParams.params)

  const params = useMemo(
    () => ({
      token: searchParams.get('token'),
      // gameCode is used uppercased everywhere (registry keys, theme lookup),
      // so normalise it here regardless of how it arrives in the URL.
      gameCode: convertCase({ value: searchParams.get('gameCode') }),
      theme: searchParams.get('theme') || 'DEFAULT',
      replay: searchParams.get('replay') || false,
    }),
    [searchParams]
  )

  const missingParams = useMemo(() => REQUIRED_PARAMS.filter((key) => !params[key]), [params])

  const isResolved = REQUIRED_PARAMS.every((key) => storedParams[key] === params[key])

  const launchStatus = !isResolved ? RESOLVING : missingParams.length > 0 ? INCOMPLETE : READY

  useEffect(() => {
    dispatch(setLaunchParams(params))
  }, [dispatch, params])

  return { params, launchStatus, missingParams }
}
